/**
 * @file useUpload.ts
 * @author markJia(markjia@tencent.com)
 */
import { useContext } from 'react';
import { UploadContext } from '../context/UploadContext';
export var useUpload = function useUpload() {
  var value = useContext(UploadContext);

  if (!value) {
    throw 'useUpload must under <UploadContext>';
  }

  return value;
};